import { useQuery } from "react-query"
import { getCancelToken } from "clients/phronesisClient"
import { AxiosError, CancelToken } from "axios"

interface OptionsProps {
	enabled: boolean
	retry?: boolean | number
}
export const useFetchData = <Type>(
	queryId: string,
	fetch: (cancelToken: CancelToken, params: any) => Promise<Type>,
	params?: any,
	options: OptionsProps = { enabled: true, retry: true }
) => {
	const { enabled, retry } = options
	const {
		data,
		isFetching,
		refetch,
		remove,
		isError,
		error,
		isSuccess,
		isLoading,
	} = useQuery<any, AxiosError>(
		[queryId, params],
		() => {
			const cancelToken = getCancelToken()
			return fetch(cancelToken.token, params)
		},
		{
			retry,
			refetchOnReconnect: false,
			refetchOnWindowFocus: false,
			enabled,
		}
	)

	return {
		data,
		isFetching,
		refetch,
		remove,
		isError,
		error,
		isSuccess,
		isLoading,
	} as const
}
